/* Perito Moreno by Zoon Network · Monthly Bangers sign-ups: the WhatsApp number typed by the shopper goes to Shopify as +91… (hidden contact[phone]) */
(() => {
  'use strict';
  if (window.PM_MB) return; window.PM_MB = true;
  const fix = v => { let d = String(v || '').replace(/\D/g, ''); if (!d) return ''; if (d.length === 11 && d[0] === '0') d = d.slice(1); if (d.length === 10) d = '91' + d; return '+' + d };
  const sync = e => { const i = e.target; if (!(i instanceof HTMLInputElement) || !i.matches('[data-wa]')) return; const o = i.form && i.form.querySelector('[data-wa-out]'); if (o) o.value = fix(i.value) };
  /* one name box (no name of its own): first word → contact[first_name], the rest → contact[last_name] */
  const nm = e => { const i = e.target; if (!(i instanceof HTMLInputElement) || !i.matches('[data-fullname]') || !i.form) return; const w = i.value.trim().split(/\s+/), f = i.form.querySelector('[data-firstname]'), l = i.form.querySelector('[data-lastname]'); if (f) f.value = w[0] || ''; if (l) l.value = w.slice(1).join(' ') };
  document.addEventListener('input', nm, true);
  document.addEventListener('change', nm, true);
  document.addEventListener('input', sync, true);
  document.addEventListener('change', sync, true);
  /* Shopify's customer form keeps only the email and the tags, so the name and number also travel as tags
     (name:…, wa:+91…). The Monthly Bangers Membership app reads them back. */
  const tags = e => {
    const f = e.target && e.target.form; const t = f && f.querySelector('input[name="contact[tags]"]'); if (!t) return;
    if (t.dataset.base == null) t.dataset.base = t.value;
    const n = f.querySelector('[data-fullname]'), w = f.querySelector('[data-wa]'), extra = [];
    const name = n ? n.value.replace(/,/g, ' ').replace(/\s+/g, ' ').trim().slice(0, 60) : '';
    const wa = w ? fix(w.value) : '';
    if (name) extra.push('name:' + name);
    if (wa.length > 9) extra.push('wa:' + wa);
    t.value = [t.dataset.base, ...extra].filter(Boolean).join(',');
  };
  document.addEventListener('input', tags, true);
  document.addEventListener('change', tags, true);
  /* Ask a key for a friend: the form goes to the Perito Moreno Admin app (/apps/mb/friend). Refusals come back as a code; the words are on the block, in data attributes. */
  document.addEventListener('submit', async e => {
    const f = e.target;
    if (!(f instanceof HTMLFormElement) || !f.matches('[data-mbm-friend]') || e.defaultPrevented) return;
    e.preventDefault();
    if (f.getAttribute('aria-busy') === 'true') return;
    const done = f.querySelector('[data-mbm-done]'), fields = f.querySelector('[data-mbm-fields]'), left = f.querySelector('[data-f-left]'), again = f.querySelector('[data-f-again]');
    const busy = on => { on ? f.setAttribute('aria-busy', 'true') : f.removeAttribute('aria-busy'); f.querySelectorAll('button').forEach(b => b.disabled = on) };
    const w = f.querySelector('[data-wa]'), o = f.querySelector('[data-wa-out]'), who = f.querySelector('[name=name]'); o.value = fix(w.value);
    /* the theme's field check clears .ferr lines, so this one may be gone */
    let err = f.querySelector('[data-mbm-err]');
    if (!err) { err = document.createElement('small'); err.className = 'ferr'; err.setAttribute('role', 'alert'); err.dataset.mbmErr = ''; fields.append(err) }
    busy(true); err.hidden = true;
    let code = 'error';
    try {
      const res = await fetch(f.action, { method: 'POST', body: new URLSearchParams(new FormData(f)), headers: { Accept: 'application/json' }, credentials: 'same-origin' });
      const data = await res.json().catch(() => null);
      if (res.status === 401) { location.reload(); return }
      if (data && data.ok) {
        const fill = t => t.replaceAll('[key]', data.key).replaceAll('[email]', data.email).replaceAll('[name]', who.value.trim());
        f.querySelectorAll('[data-tpl]').forEach(n => n.textContent = fill(n.dataset.tpl));
        f.dataset.copy = fill(f.dataset.send);
        left.textContent = data.left > 0 ? f.dataset.left.replace('[left]', data.left) : f.dataset.left_none;
        if (again) again.hidden = data.left < 1;
        fields.hidden = true; done.hidden = false; done.focus({ preventScroll: true });
        busy(false); return;
      }
      if (data && data.code) code = data.code;
    } catch (x) { }
    err.textContent = f.dataset[code] || f.dataset.error; err.hidden = false;
    busy(false);
  });
  document.addEventListener('click', async e => {
    const c = e.target.closest && e.target.closest('[data-f-copy]'), a = e.target.closest && e.target.closest('[data-f-again]');
    if (a) { const f = a.closest('form'); f.reset(); f.querySelector('[data-mbm-done]').hidden = true; f.querySelector('[data-mbm-fields]').hidden = false; f.querySelector('[name=name]').focus(); return }
    if (!c) return;
    const f = c.closest('form'), text = f.dataset.copy, was = c.dataset.was || (c.dataset.was = c.textContent);
    try { await navigator.clipboard.writeText(text) } catch (x) { const t = document.createElement('textarea'); t.value = text; t.style.position = 'fixed'; t.style.opacity = '0'; document.body.append(t); t.select(); document.execCommand('copy'); t.remove() }
    c.textContent = f.dataset.copied; setTimeout(() => c.textContent = was, 1800);
  });
})();